module.exports = __webpack_public_path__ + "img/TCPL5.png";